// src/features/engine/tasks/osrboi/services/buildOSRBOIFeedback.js

export function buildOSRBOIFeedback(sharedAssessments, currentRatings) {

  const referenceRatings =
    sharedAssessments.filter(a => a.raterSource === "quebecRater");

  const attributes = [
    "overallSeverity",
    "roughness",
    "breathiness"
  ];

  const feedback = {};

  // ===============================================================
  // NUMERIC ATTRIBUTES (VAS)
  // ===============================================================

  attributes.forEach(attr => {

    feedback[attr] = {
      sharedValues: referenceRatings
        .map(a => a.perceptualData?.[attr]?.VASValue)
        .filter(v => typeof v === "number")
        .map(value => ({ value })),

      userValues: currentRatings
        ? [{ value: currentRatings[attr] }]
        : []
    };

  });

  // ===============================================================
  // 🔥 OVERALL IMPRESSION (COMMENTS)
  // ===============================================================

  const userComment =
    currentRatings?.overallImpressionComment || "-";

const sharedComments = referenceRatings
  .map(a => a.perceptualData?.overallImpression)
  .filter(c => typeof c === "string" && c.trim() !== "");

  feedback.overallImpression = {
    user: userComment,
    shared: sharedComments
  };

  return feedback;
}